// extracted by mini-css-extract-plugin
export default {"colorButtons":"ColorPicker_colorButtons__Cz0xJ","colorButton":"ColorPicker_colorButton__l7B4J"};